import { Layers } from 'lucide-react';
import { useImageUrl } from '../db/useImageUrl';

/**
 * What a section looks like before anyone gives it a picture: the four newest
 * things inside it, in a quad. One thing fills the frame, two split it, three
 * or four make the grid — so a section reads as its contents rather than as a
 * box with a label.
 *
 * A section with a cover of its own uses that instead; this is the fallback.
 */
export function SectionCover({
  coverImageId,
  covers,
}: {
  coverImageId: string | undefined;
  /** Up to four image ids, newest first. */
  covers: readonly string[];
}) {
  if (coverImageId !== undefined) {
    return (
      <div className="section-cover section-cover--single">
        <Photo imageId={coverImageId} />
      </div>
    );
  }

  if (covers.length === 0) {
    return (
      <div className="section-cover section-cover--empty">
        <Layers size={28} aria-hidden />
      </div>
    );
  }

  return (
    <div className={`section-cover section-cover--${Math.min(covers.length, 4)}`}>
      {covers.slice(0, 4).map((id) => (
        <Photo key={id} imageId={id} />
      ))}
    </div>
  );
}

/** Its own component so each photo gets its own refcounted object URL. */
function Photo({ imageId }: { imageId: string }) {
  const url = useImageUrl(imageId);
  return (
    <div className="section-cover__cell">
      {url !== undefined && <img className="section-cover__image" src={url} alt="" draggable={false} />}
    </div>
  );
}
